import { checkMaxActivities } from './utils/activityUtils.js';

(function () {
  // Function to add input event listeners for custom titles
  const addCustomTitleListeners = section => {
    const customTitles = section.querySelectorAll(
      '.full-content-custom-title input[type="text"]'
    );

    customTitles.forEach(function (customTitle) {
      const parentSection = customTitle.closest('.evaluation-form-item');

      customTitle.addEventListener('input', function () {
        let title = parentSection.querySelector('.custom_title');
        if (title) {
          title.textContent = this.value;
        }
      });
    });
  };

  // Add listeners to initial sections
  document.querySelectorAll('.evaluation-form-item').forEach(section => {
    addCustomTitleListeners(section);
  });

  // Function to handle measure checkbox clicks
  const handleMeasureClick = measure => {
    const parentSection = measure.closest('.evaluation-form-item');
    let measuresChecked = parentSection.querySelectorAll(
      '.full-content-body input[type="checkbox"]:checked'
    );

    const activityCheck = parentSection.querySelector(
      '.activity_name-selected input[type="checkbox"]'
    );

    if (measuresChecked.length > 0) {
      if (parentSection) {
        activityCheck.checked = true;
        parentSection.classList.add('is-selected');
      }
    } else {
      activityCheck.checked = false;
      parentSection.classList.remove('is-selected');
    }
  };

  // Use event delegation for measure checkboxes
  document.addEventListener('click', function (event) {
    if (event.target.matches('.full-content-body input[type="checkbox"]')) {
      handleMeasureClick(event.target);
    }
  });

  // Function to update activities order
  const updateActivitiesOrder = () => {
    const activities = document.querySelectorAll('.evaluation-form-item');
    const orderInput = document.getElementById('activities-order');
    if (orderInput) {
      const order = Array.from(activities)
        .map(activity => {
          const counterInput = activity.querySelector(
            'input[name*="-counter"]'
          );
          return counterInput ? counterInput.value : '';
        })
        .filter(Boolean)
        .join(',');
      orderInput.value = order;
    }
  };

  // Update order on page load
  updateActivitiesOrder();

  // Add this function at the top
  function getHighestId() {
    const counterInputs = document.querySelectorAll('input[name*="-counter"]');
    let maxId = -1;

    // Get all existing IDs
    counterInputs.forEach(input => {
      const value = parseInt(input.value);
      if (!isNaN(value)) {
        maxId = Math.max(maxId, value);
      }
    });

    // Get deleted IDs from hidden input if it exists
    const deletedInput = document.getElementById('deleted-activities');
    const deletedIds = new Set();
    if (deletedInput && deletedInput.value) {
      deletedInput.value.split(',').forEach(id => {
        const numId = parseInt(id);
        if (!isNaN(numId)) {
          deletedIds.add(numId);
        }
      });
    }

    // Find the next available ID that is greater than maxId and not in deletedIds
    let nextId = maxId;
    while (deletedIds.has(nextId)) {
      nextId++;
    }

    return nextId;
  }

  // Function to handle activity duplication
  const handleActivityDuplication = duplicateButton => {
    const parentSection = duplicateButton.closest('.evaluation-form-item');
    const activityParent = document.querySelector('.js-evaluation-group');
    const clonedSection = parentSection.cloneNode(true);

    // Get the highest existing ID and increment by 1
    const newId = getHighestId() + 1;

    // Update counter input in cloned section
    const counterInput = clonedSection.querySelector('input[name*="-counter"]');
    if (counterInput) {
      counterInput.value = newId;
    }

    // Clear ID field in cloned section
    const idInput = clonedSection.querySelector('input[name*="-id"]');
    if (idInput) {
      idInput.value = '';
    }

    // Close the parent section first
    const parentClose = parentSection.querySelector('.btn-disclosure');
    if (parentClose) {
      // Prevent scroll when closing parent
      const originalScrollIntoView = Element.prototype.scrollIntoView;
      Element.prototype.scrollIntoView = function () {};
      parentClose.click();
      Element.prototype.scrollIntoView = originalScrollIntoView;
    }

    // Update the clear button to be a delete button
    const clearButton = clonedSection.querySelector('.js-clear-activity');
    if (clearButton) {
      clearButton.classList.remove('js-clear-activity');
      clearButton.classList.add('js-delete-activity');
      clearButton.dataset.target = 'deleteConfirmationModal';
      clearButton.textContent = 'Delete activity';
    }

    // Update toggle button and content IDs only in the cloned section
    const toggleButton = clonedSection.querySelector('.btn-disclosure');
    const fullContent = clonedSection.querySelector('.full-content');
    if (toggleButton && fullContent) {
      const newContentId = `activity-${newId}`;
      fullContent.id = newContentId;
      toggleButton.setAttribute('aria-controls', newContentId);
      toggleButton.setAttribute('aria-expanded', 'false');
      fullContent.setAttribute('hidden', 'true');
      fullContent.setAttribute('aria-hidden', 'true');
    }

    // Update process and impact measure toggle buttons and content IDs only in the cloned section
    const processToggles = clonedSection.querySelectorAll(
      '.js-process-form .toggle-content'
    );
    processToggles.forEach((toggle, index) => {
      const content = toggle.nextElementSibling;
      if (content) {
        const newContentId = `process-form-${newId}-${index}`;
        content.id = newContentId;
        toggle.setAttribute('aria-controls', newContentId);
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    const impactToggles = clonedSection.querySelectorAll(
      '.js-impact-form .toggle-content'
    );
    impactToggles.forEach((toggle, index) => {
      const content = toggle.nextElementSibling;
      if (content) {
        const newContentId = `impact-form-${newId}-${index}`;
        content.id = newContentId;
        toggle.setAttribute('aria-controls', newContentId);
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Clear form fields
    clearFormFields(clonedSection);

    // Add custom title listeners to the cloned section
    addCustomTitleListeners(clonedSection);

    // Update all form fields in the cloned section
    const updateFormFields = (section, total) => {
      // Update all inputs, textareas, and labels
      section.querySelectorAll('input, textarea, select').forEach(field => {
        if (field.id) {
          const oldId = field.id;
          const newId = field.id.replace(/\d+/, total);
          field.id = newId;

          // Find and update corresponding label
          const label = section.querySelector(`label[for="${oldId}"]`);
          if (label) {
            label.setAttribute('for', newId);
          }
        }

        if (field.name) {
          field.name = field.name.replace(/\d+/, total);
        }
      });

      // Update process measures formset
      const processFormset = section.querySelector('.js-process-form');
      if (processFormset) {
        processFormset
          .querySelectorAll('.simple-card')
          .forEach((card, index) => {
            card.querySelectorAll('[id], [name]').forEach(element => {
              if (element.id) {
                const oldId = element.id;
                const newId = element.id.replace(
                  /\d+-\d+/,
                  `${total}-${index}`
                );
                element.id = newId;

                // Find and update corresponding label
                const label = card.querySelector(`label[for="${oldId}"]`);
                if (label) {
                  label.setAttribute('for', newId);
                }
              }
              if (element.name) {
                element.name = element.name.replace(
                  /\d+-\d+/,
                  `${total}-${index}`
                );
              }
            });
          });
      }

      // Update impact measures formset
      const impactFormset = section.querySelector('.js-impact-form');
      if (impactFormset) {
        impactFormset
          .querySelectorAll('.simple-card')
          .forEach((card, index) => {
            card.querySelectorAll('[id], [name]').forEach(element => {
              if (element.id) {
                const oldId = element.id;
                const newId = element.id.replace(
                  /\d+-\d+/,
                  `${total}-${index}`
                );
                element.id = newId;

                // Find and update corresponding label
                const label = card.querySelector(`label[for="${oldId}"]`);
                if (label) {
                  label.setAttribute('for', newId);
                }
              }
              if (element.name) {
                element.name = element.name.replace(
                  /\d+-\d+/,
                  `${total}-${index}`
                );
              }
            });
          });
      }

      // Update management form if exists
      const managementForms = section.querySelectorAll(
        '[name$="TOTAL_FORMS"], [name$="INITIAL_FORMS"]'
      );
      managementForms.forEach(form => {
        if (form.name) {
          form.name = form.name.replace(/\d+/, total);
        }
      });
    };

    // Call the update function after cloning
    updateFormFields(clonedSection, newId);

    activityParent.insertBefore(clonedSection, parentSection.nextSibling);

    // Update total forms count
    const totalForms = document.querySelector('input[name="TOTAL_FORMS"]');
    if (totalForms) {
      totalForms.value = newId + 1;
    }

    // Update activities order after duplication
    updateActivitiesOrder();

    // Wait briefly before opening the cloned section
    setTimeout(() => {
      // Find and open the cloned section
      const clonedToggle = clonedSection.querySelector('.btn-disclosure');
      if (clonedToggle) {
        // Remove hidden attributes and set expanded state
        const contentId = clonedToggle.getAttribute('aria-controls');
        const content = document.getElementById(contentId);
        if (content) {
          // Prevent default scroll behavior from disclosure.js
          const originalScrollIntoView = Element.prototype.scrollIntoView;
          Element.prototype.scrollIntoView = function () {};

          content.removeAttribute('hidden');
          content.setAttribute('aria-hidden', 'false');
          clonedToggle.setAttribute('aria-expanded', 'true');

          // Update button text and container class
          if (clonedToggle.classList.contains('btn-activity')) {
            clonedToggle.textContent = 'Close';
          }
          const container = clonedSection.closest('.full-content-container');
          if (container) {
            container.classList.add('open');
          }

          // Restore scrollIntoView and perform our own scroll
          Element.prototype.scrollIntoView = originalScrollIntoView;
          clonedSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

          // Focus on the first input field (custom title input)
          setTimeout(() => {
            const firstInput = content.querySelector('input[type="text"]');
            if (firstInput) {
              firstInput.focus();
            }
          }, 100); // Small delay to ensure the section is fully opened
        }
      }
    }, 350);

    checkMaxActivities();
  };

  // Use event delegation for duplicate buttons
  document.addEventListener('click', function (event) {
    const duplicateButton = event.target.closest('.btn-add-activity');
    if (duplicateButton) {
      const activityItems = document.querySelectorAll('.js-evaluation-forms');
      // Check if we already have 9 forms (show modal for last possible addition)
      if (activityItems.length === 9) {
        const maxModal = document.getElementById(
          'maxActivityConfirmationModal'
        );
        const modalOverlay = document.getElementById('modalOverlay');

        if (maxModal) {
          maxModal.removeAttribute('aria-hidden');
          maxModal.classList.add('open');
          modalOverlay.style.display = 'block';

          // Handle create activity button
          const createButton = maxModal.querySelector('.js-activity');
          if (createButton) {
            createButton.addEventListener(
              'click',
              function () {
                maxModal.setAttribute('aria-hidden', 'true');
                maxModal.classList.remove('open');
                modalOverlay.style.display = 'none';
                handleActivityDuplication(duplicateButton);
              },
              { once: true }
            );
          }
        }
      } else if (activityItems.length < 9) {
        // Directly duplicate if less than 9 activities
        handleActivityDuplication(duplicateButton);
      }
      // If 10 or more activities, the button will be disabled so no action needed
    }
  });

  const clearFormFields = section => {
    // Close any expanded process or impact measures
    const expandedContents = section.querySelectorAll(
      '.simple-card .full-content:not([hidden])'
    );
    expandedContents.forEach(content => {
      content.setAttribute('hidden', 'true');
      content.setAttribute('aria-hidden', 'true');
      const toggle =
        content.previousElementSibling.querySelector('.toggle-content');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Remove pre-configured measures - updated selector to handle dynamic attributes
    const processCards = section.querySelectorAll(
      '.js-process-form .simple-card'
    );
    const impactCards = section.querySelectorAll(
      '.js-impact-form .simple-card'
    );

    // Helper function to check and remove pre-configured cards
    const removeIfPreConfigured = card => {
      const preConfiguredInput = card.querySelector(
        'input[type="hidden"][name*="is_pre_configured"]'
      );
      if (
        preConfiguredInput &&
        preConfiguredInput.value.toLowerCase() === 'false'
      ) {
        // Get the parent evaluation form before removing the card
        const parentForm = card.closest('.js-evaluation-form');
        card.remove();

        // Update TOTAL_FORMS
        if (parentForm) {
          const totalFormsInput = parentForm.querySelector(
            'input[name*="TOTAL_FORMS"]'
          );
          if (totalFormsInput) {
            let currentTotal = parseInt(totalFormsInput.value);
            totalFormsInput.value = Math.max(0, currentTotal - 1);
          }
        }
      }
    };

    // Check both process and impact cards
    processCards.forEach(removeIfPreConfigured);
    impactCards.forEach(removeIfPreConfigured);

    // Clear all visible inputs, textareas, and checkboxes
    const formInputs = section.querySelectorAll(
      'input:not([type="hidden"]), textarea'
    );
    formInputs.forEach(input => {
      if (input.type === 'checkbox') {
        input.checked = false;
      } else {
        input.value = '';
      }
    });

    // Clear all checkboxes in process and impact measures and remove is-selected class
    const measureCards = section.querySelectorAll('.simple-card');
    measureCards.forEach(card => {
      const checkbox = card.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = false;
        card.classList.remove('is-selected');
      }
    });

    // Clear custom title
    const customTitle = section.querySelector('.custom_title');
    if (customTitle) {
      customTitle.textContent = '';
    }

    // Remove selected states
    section.classList.remove('is-selected');

    // Clear all description outputs
    const descriptionOutputs = section.querySelectorAll(
      'textarea[name*="description_of_output"]'
    );
    descriptionOutputs.forEach(textarea => {
      textarea.value = '';
    });

    // Clear all targets and actuals
    const numberInputs = section.querySelectorAll(
      'input[name*="target"], input[name*="actual"]'
    );
    numberInputs.forEach(input => {
      input.value = '';
    });

    // Clear all collection method descriptions
    const collectionMethods = section.querySelectorAll(
      'textarea[name*="collection_method_description"]'
    );
    collectionMethods.forEach(textarea => {
      textarea.value = '';
    });

    // Remove any error messages
    const errorMessages = section.querySelectorAll('.fieldErrorWrapper');
    errorMessages.forEach(error => {
      error.classList.remove('error');
      error.textContent = '';
    });

    // Hide any status messages
    const statusBars = section.querySelectorAll('.status-bar:not([hidden])');
    statusBars.forEach(status => {
      status.setAttribute('hidden', 'true');
    });
  };
})();
